import { c as _c } from "react/compiler-runtime";
import { cn } from "utils/helpers/cn";
export type UploadProgressUiState = {
  percent: number;
};
export interface UploadProgressBarProps {
  progress: UploadProgressUiState | null;
  label: string;
  processingText?: string;
  className?: string;
}
const progressFocusRing = "rounded-full focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2";

/**
 * Native `<progress>` with explicit ARIA mirrors (recommended for AT parity across browsers).
 * @see https://www.atomica11y.com/accessible-web/progress/
 */
export default function UploadProgressBar(t0) {
  const $ = _c(17);
  const {
    progress,
    label,
    processingText,
    className
  } = t0;
  if (!progress) {
    return null;
  }
  const isProcessing = progress.percent >= 100;
  const footnote = isProcessing ? processingText : `${progress.percent}%`;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex w-full flex-col gap-1", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = progress.percent;
  const t3 = isProcessing || undefined;
  const t4 = progress.percent;
  const t5 = isProcessing && "upload-progress-processing";
  let t6;
  if ($[2] !== t5) {
    t6 = cn("upload-progress-native h-2 w-full appearance-none rounded-full", t5, progressFocusRing);
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== footnote || $[5] !== label || $[6] !== progress.percent || $[7] !== t3 || $[8] !== t6) {
    t7 = <progress max={100} value={t2} tabIndex={0} aria-label={label} aria-busy={t3} aria-valuemin={0} aria-valuenow={t4} aria-valuemax={100} aria-valuetext={footnote} className={t6} />;
    $[4] = footnote;
    $[5] = label;
    $[6] = progress.percent;
    $[7] = t3;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== footnote || $[11] !== isProcessing) {
    t8 = footnote ? <span aria-hidden={isProcessing ? undefined : true} className={cn("text-font-2 text-xs", !isProcessing && "self-end tabular-nums")}>{footnote}</span> : null;
    $[10] = footnote;
    $[11] = isProcessing;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t1 || $[14] !== t7 || $[15] !== t8) {
    t9 = <div className={t1}>{t7}{t8}</div>;
    $[13] = t1;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}